export default "__VITE_ASSET__ClEYnXXE__"